/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Mission Impact Auth API
 * OpenAPI spec version: v1
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type {
  ProblemDetails,
  ProvisionUserRequest,
  ProvisionUserResponse,
} from '../missionImpactAuthAPI.schemas';

import { instance } from '../../mutator-auth';
import type { ErrorType } from '../../mutator-auth';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Idempotent user provisioning. Supports both authenticated (JWT-based) and unauthenticated (email-based) provisioning. For authenticated requests, user information is extracted from the JWT token. For unauthenticated requests, provide email, firstName, and lastName in the request body.
 * @summary Provision user
 */
export const postUsersProvision = (
  provisionUserRequest: ProvisionUserRequest,
  options?: SecondParameter<typeof instance>,
  signal?: AbortSignal
) => {
  return instance<ProvisionUserResponse | ProvisionUserResponse | void>(
    {
      url: `/v1/users:provision`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: provisionUserRequest,
      signal,
    },
    options
  );
};

export const getPostUsersProvisionMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postUsersProvision>>,
    TError,
    { data: ProvisionUserRequest },
    TContext
  >;
  request?: SecondParameter<typeof instance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postUsersProvision>>,
  TError,
  { data: ProvisionUserRequest },
  TContext
> => {
  const mutationKey = ['postUsersProvision'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postUsersProvision>>,
    { data: ProvisionUserRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postUsersProvision(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostUsersProvisionMutationResult = NonNullable<
  Awaited<ReturnType<typeof postUsersProvision>>
>;
export type PostUsersProvisionMutationBody = ProvisionUserRequest;
export type PostUsersProvisionMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Provision user
 */
export const usePostUsersProvision = <TError = ErrorType<ProblemDetails>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postUsersProvision>>,
      TError,
      { data: ProvisionUserRequest },
      TContext
    >;
    request?: SecondParameter<typeof instance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postUsersProvision>>,
  TError,
  { data: ProvisionUserRequest },
  TContext
> => {
  const mutationOptions = getPostUsersProvisionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
